import React, { useRef, useEffect } from 'react';
import { styled } from '../../../libs/styled.es.js';
import { DropdownProvider } from './DropdownContext.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DropdownWrapper = styled.div`
  width: 100%;
`;
const Dropdown = (_a) => {
  var _b = _a, {
    children,
    isOpen,
    toggle,
    toggleType = "click",
    className,
    onHide
  } = _b, props = __objRest(_b, [
    "children",
    "isOpen",
    "toggle",
    "toggleType",
    "className",
    "onHide"
  ]);
  const wrapperRef = useRef(null);
  useEffect(() => {
    if (!isOpen) {
      return;
    }
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        toggle();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef, isOpen]);
  return /* @__PURE__ */ React.createElement(DropdownProvider, {
    value: { isOpen, toggle, toggleType }
  }, /* @__PURE__ */ React.createElement(DropdownWrapper, __spreadValues({
    onMouseEnter: toggleType === "hover" ? toggle : null,
    onMouseLeave: toggleType === "hover" ? onHide : null,
    className,
    ref: wrapperRef
  }, props), children));
};

export { Dropdown };
